module.exports = __webpack_public_path__ + "img/124.2fd3665b.png";